import NavigationHistory from "../models/NavigationHistory";
import Backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import "component?js-flashSale"


export default class extends Backbone.View{
  constructor(options) {
    super(options);
  }

  initialize() {
    this.destroyHasSucceeded = this.destroyHasSucceeded.bind(this);
    this.destroyHasFailed = this.destroyHasFailed.bind(this);
      this.destroyed = false;
    }

    get events(){
      return {
        "click .js-NavigationHistory-destroy": "destroy"
      }
    }

    destroyHasSucceeded() {
      this.destroyed = true;
      this.render();
    }

    destroyHasFailed() {
      //TO DO addd destroy method
    }

    destroy () {
      NavigationHistory.destroy()
        .fail(this.destroyHasFailed)
        .done(this.destroyHasSucceeded);
    }

    render() {
      if (this.destroyed) {
        this.$el.remove();
      }
    }
  };
